import { Sort } from './sort.model';
import { HttpParams } from '@angular/common/http';

export interface Pageable {
    page?: number;
    size?: number;
    sort?: Sort | Sort[];
}

export function buildPageableQuery(params: HttpParams, page: Pageable): HttpParams {
    if (page.page) params = params.set('page', page.page);
    if (page.size) params = params.set('size', page.size);
    if (page.sort) {
        if (Array.isArray(page.sort)) {
            page.sort.forEach((sort) => (params = params.set('sort', `${sort.field},${sort.direction}`)));
        } else {
            params = params.set('sort', `${page.sort.field},${page.sort.direction}`);
        }
    }
    return params;
}
